var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.connected)?_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.connected),expression:"!connected"}],staticClass:"loading-full"}):_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }